// extracted by mini-css-extract-plugin
export default {"fontImage":"et1HJ1iKbk1rRq_Dy4k9","notSupportedImg":"FTEnMIzsmURIdBPRWsNu","fontImageContainer":"P8QQAUW1x7adIJmBuJr_","notSupported":"siVQAThWbagAfIovGM7N"};